import "./HeaderSmallScreen.css";
import menuLogo from "./burger-menu.svg";
import { useState } from "react";
import ImageFetcher from "../ImageFetcher";

const HeaderSmallScreen = ({ isScrolled, scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className={`header-small-screen ${isScrolled ? "scrolled" : ""}`}>
      <ImageFetcher image="logo-icon_fqmmpo" alt="logo" name="logo" />
      <img
        src={menuLogo}
        className="menu-logo"
        alt="menu"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      />
      <div
        className={`header-small-links-container ${isMenuOpen ? "open" : ""}`}
      >
        <button
          type="button"
          onClick={() => scrollToSection("home")}
          className="link pradžia"
        >
          <h1>Pradžia</h1>
        </button>
        <button
          type="button"
          onClick={() => scrollToSection("galerija")}
          className="link galerija"
        >
          <h1>Galerija</h1>
        </button>
        <button
          type="button"
          onClick={() => scrollToSection("about")}
          className="link apie-mane"
        >
          <h1>Apie Mane</h1>
        </button>
        <button
          type="button"
          onClick={() => scrollToSection("menu")}
          className="link kainorastis"
        >
          <h1>Kainoraštis</h1>
        </button>
        <button
          type="button"
          onClick={() => scrollToSection("taisykles")}
          className="link taisykles"
        >
          <h1>Taisyklės</h1>
        </button>
        <button
          type="button"
          onClick={() => scrollToSection("contact")}
          className="link kontaktai"
        >
          <h1>Kontaktai</h1>
        </button>
        <div className="small-social-icon-container">
          <a
            href="https://www.facebook.com/Harmonyfeelings"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageFetcher
              image="Facebook_Logo_Primary_jcacxb"
              alt="Facebook"
              name="small-facebook-icon"
              width={40}
              height={40}
            />
          </a>
          <a
            href="https://www.instagram.com/harmony_feelings"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageFetcher
              image="Instagram_Glyph_Gradient_qzf6jc"
              alt="Instagram"
              width={40}
              height={40}
              name="small-instagram-icon"
            />
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeaderSmallScreen;
